import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  type Unsubscribe,
  type User,
} from 'firebase/auth'
import { getFirebaseApp } from '../../config/firebase'

function getFirebaseAuth() {
  return getAuth(getFirebaseApp())
}

export function subscribeToAuthState(callback: (user: User | null) => void): Unsubscribe {
  return onAuthStateChanged(getFirebaseAuth(), callback)
}

export async function signIn(email: string, password: string): Promise<User> {
  const result = await signInWithEmailAndPassword(getFirebaseAuth(), email, password)
  return result.user
}

export async function signOut(): Promise<void> {
  await firebaseSignOut(getFirebaseAuth())
}
